import React, { memo } from "react";
import { getClass } from "src/utils";

import styles from "./style.css";

export const Icon = memo(props => {
  const { name, class: _class, style, bold, padding = 0, size = 1, round, color, background, ...rest } = props;

  return (
    <i
      {...rest}
      style={{
        color,
        background,
        fontSize: `${size * 1.5}rem`,
        padding: `${padding * 0.1}rem`,
        borderRadius: round ? "50%" : "0",
        fontWeight: bold ? "bold" : "normal",
        ...style
      }}
      class={getClass("material-icons", _class, styles.container)}
    >
      {name}
    </i>
  );
});
